import { SignUpFormFields } from 'config/sign_up_form';

import FirstNameInput from './first_name/FirstNameInput';
import LastNameInput from './last_name/LastNameInput';
import EmailInput from './email/EmailInput';
import PasswordInputWithValidation from './password/PasswordInputWithValidation';
import PasswordConfirmationInput from './password/PasswordConfirmationInput';

const mapStepToInput = (step) => {
  if (step === SignUpFormFields.firstName) return FirstNameInput;
  if (step === SignUpFormFields.lastName) return LastNameInput;
  if (step === SignUpFormFields.email) return EmailInput;
  if (step === SignUpFormFields.password) return PasswordInputWithValidation;
  if (step === SignUpFormFields.passwordConfirmation)
    return PasswordConfirmationInput;

  throw new Error('invalid step');
};

export default mapStepToInput;
